import { useTema, type PreferenciaTema } from '../lib/tema.js';
import { IconeLua, IconeMonitor, IconeSol } from './Icones.js';
import { ItemMenu, Menu } from './ui/index.js';

const OPCOES: Array<{ valor: PreferenciaTema; rotulo: string; Icone: typeof IconeSol }> = [
  { valor: 'claro', rotulo: 'Claro', Icone: IconeSol },
  { valor: 'escuro', rotulo: 'Escuro', Icone: IconeLua },
  { valor: 'sistema', rotulo: 'Igual ao sistema', Icone: IconeMonitor },
];

/** Um botao so no topo; as tres opcoes ficam no menu. */
export function SeletorTema() {
  const { preferencia, escolher, escuroEfetivo } = useTema();
  const IconeAtual = preferencia === 'sistema' ? IconeMonitor : escuroEfetivo ? IconeLua : IconeSol;
  return (
    <Menu
      rotulo="Tema"
      classeGatilho="flex size-9 items-center justify-center rounded-(--radius-controle) text-nevoa hover:bg-gelo/8 hover:text-gelo"
      gatilho={<IconeAtual />}
    >
      {(fechar) => (
        <>
          <p className="rotulo-secao px-3 pt-1 pb-2">Tema</p>
          {OPCOES.map(({ valor, rotulo, Icone }) => (
            <ItemMenu
              key={valor}
              marcado={preferencia === valor}
              onClick={() => {
                escolher(valor);
                fechar();
              }}
            >
              <Icone width={16} height={16} className="text-apagado" />
              {rotulo}
            </ItemMenu>
          ))}
        </>
      )}
    </Menu>
  );
}
